import VideoIcon from '@/assets/video.svg?react'
import ClickWrapper from '@/components/ClickWrapper'
import { selectFiles } from '@/utils/file'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './VideoAttachmentPicker.module.css'

export interface VideoAttachmentPickerProps extends Omit<
	HTMLAttributes<HTMLDivElement>,
	'onSelect'
> {
	onSelect?: (files: File[]) => void
	disabled?: boolean
}

export default function VideoAttachmentPicker({
	disabled,
	onSelect,
	...props
}: VideoAttachmentPickerProps) {
	return (
		<ClickWrapper
			className={styles.root}
			title="视频"
			onClick={() => {
				selectFiles({
					multiple: true,
					accept: 'video/*',
				}).then((files) => {
					onSelect?.(files)
				})
			}}
		>
			<VideoIcon className={clsx(styles.icon, disabled && styles.iconDisabled)} />
		</ClickWrapper>
	)
}
